import { createRipples } from "react-ripples"

export const Ripple = createRipples({
  color: "rgba(225, 225, 225, .5)",
  during: 1000,
})
